import Axios from 'axios';
import { REACT_APP_DOMAIN } from '~/utils/config';

const axios = Axios.create({
  baseURL: REACT_APP_DOMAIN,
});

export { axios };
